import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import _ from "lodash";
import Close from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  indeterminateColor: {
    color: "#399EBE",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  whiteBackground: {
    backgroundColor: "red",
  },
  formControl: {
    width: "100%",
    backgroundColor: "#FFF",
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 3,
    background: "#E1F3FB",
    color: "#757A93",
    fontWeight: 600,
    height: 20,
    "&:hover": {
      background: "#E1F3FB",
    },
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  select: {
    height: "auto",
    width: "100%",
  },
  inputLabel: {
    backgroundColor: "white",
    paddingLeft: 5,
    paddingRight: 5,
    zIndex: 1,
  },
  closeIcon: {
    color: "white",
    background: "#399EBE",
    borderRadius: "50%",
    height: 13,
    width: 13,
    marginLeft: 5,
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "40vw",
    },
  },
  getContentAnchorEl: null as any,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};

export { useStyles, MenuProps };

interface ISelectMultiple {
  label?: string;
  options?: any[];
  onChange: (value: any[]) => void;
  noItemAvailable?: string;
  error?: boolean;
  isEdit?: boolean;
  selectedOption?: any[];
  isProducts?: boolean;
}

const SelectMultiple = ({
  label,
  options,
  noItemAvailable,
  error,
  isEdit,
  selectedOption,
  onChange,
  isProducts,
}: ISelectMultiple) => {
  const classes = useStyles();
  const [selected, setSelected] = useState(selectedOption);
  const isAllSelected = options?.length > 0 && selected.length === options?.length;

  const handleChange = (event: any) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options?.length ? [] : options);
      onChange(selected.length === options?.length ? [] : options);
      return;
    }

    setSelected(value);
    onChange(value);
  };

  const handleDelete = (e: React.MouseEvent, value: any) => {
    e.preventDefault();
    setSelected((current) => _.without(current, value));
    onChange(_.without(selected, value));
  };

  useEffect(() => {
    setSelected(selectedOption);
  }, [options]);

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel className={classes.inputLabel} shrink id="mutiple-select-label">
        {label}
      </InputLabel>
      <Select
        className={classes.select}
        fullWidth
        labelId="mutiple-select-label"
        multiple
        value={selected}
        onChange={handleChange}
        variant="outlined"
        MenuProps={MenuProps as any}
        error={error}
        renderValue={(selected) => (
          <div className={classes.chipContainer}>
            {(selected as any[]).map((value) => (
              <Chip
                key={value?.code}
                label={`${value?.name} (x${value?.quantity})`}
                clickable
                deleteIcon={
                  <Close className={classes.closeIcon} onMouseDown={(event: any) => event.stopPropagation()} />
                }
                className={classes.chip}
                onDelete={(e) => handleDelete(e, value)}
              />
            ))}
          </div>
        )}
      >
        <MenuItem
          value="all"
          classes={{
            root: isAllSelected ? classes.selectedAll : "",
          }}
        >
          {options?.length && isProducts ? (
            <>
              <ListItemIcon>
                <Checkbox
                  classes={{ indeterminate: classes.indeterminateColor }}
                  checked={isAllSelected}
                  indeterminate={selected.length > 0 && selected.length < options?.length}
                />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.selectAllText }} primary="All" />
            </>
          ) : (
            <Typography>{noItemAvailable}</Typography>
          )}
        </MenuItem>
        {options?.length &&
          isProducts &&
          options?.map((option) => (
            <MenuItem key={option?.code} value={option}>
              <ListItemIcon>
                {!!option?.name && <Checkbox checked={selected.findIndex((i) => i.name === option?.name) > -1} />}
              </ListItemIcon>
              <ListItemText primary={`${option?.name} (x${option?.quantity})`} />
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default SelectMultiple;
